import { DataBean } from "../DataBean";

export class IncapacityStateConstants extends DataBean {



    public async getEmployeeIncapacityStateConstants(ID:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getEmployeeIncapacityStateConstants_Number", [ID]);
    }
} 